import { Component, Inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { GridApiService } from '../../../components/wc-grid/services/grid-api.service';
import { LookupOption } from '../../../components/wc-grid/grid-types';

export interface TargetWellPickerData {
  dataFeedId: string;
  sourceId: string;
  sourceWellName?: string | null;
  sourceApi?: string | null;
}

/**
 * "Map (Assisted)" picker: searches sec.IX_Wells for the data feed's target client
 * (via the legacyXRef grid's "targetWell" lookup) and lets the admin pick one well.
 * Closing with a result hands back the raw LookupOption (value = IX_Wells.Id_Source).
 */
@Component({
  selector: 'app-target-well-picker',
  standalone: true,
  templateUrl: './target-well-picker.component.html',
  styleUrls: ['./target-well-picker.component.css'],
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatListModule],
})
export class TargetWellPickerComponent implements OnDestroy {
  search = '';
  options: LookupOption[] = [];
  loading = false;
  private debounceHandle: ReturnType<typeof setTimeout> | undefined;

  constructor(
    private gridApi: GridApiService,
    public dialogRef: MatDialogRef<TargetWellPickerComponent, LookupOption | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: TargetWellPickerData,
  ) {
    this.runSearch();
  }

  onSearchChange(): void {
    clearTimeout(this.debounceHandle);
    this.debounceHandle = setTimeout(() => this.runSearch(), 300);
  }

  private runSearch(): void {
    this.loading = true;
    this.gridApi.lookup(
      'legacyXRef', 'targetWell',
      { search: this.search.trim() || null, take: 50, context: { dataFeedId: this.data.dataFeedId } },
      (opts: LookupOption[]) => { this.options = opts; this.loading = false; }
    );
  }

  select(option: LookupOption): void {
    this.dialogRef.close(option);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }

  ngOnDestroy(): void {
    clearTimeout(this.debounceHandle);
  }
}
